import * as Sentry from "@sentry/vue";

import config from "@/app/config.js";

const isSentryEnabled = () => config.VITE_APP_IS_ONPREM !== "on";

export const setSentryUser = (user) => {
  if (!isSentryEnabled() || !user) return;
  // Only send user ID to avoid PII in Sentry
  Sentry.setUser({ id: user.id });
};

export const clearSentryUser = () => {
  if (!isSentryEnabled()) return;
  Sentry.setUser(null);
};
